module.exports = __webpack_public_path__ + "img/crosshair.fb73de36.png";